import React from 'react';


const NavBar = ({ setCurrentPage }) => {
  return (
    <nav className="top-nav">
      <a href="/">Home</a>
      <a href="/#about">About</a>
      <a href="/#portfolio">Projects</a>
      <a href="https://coaching.idamayer.com">Coaching</a>
      <a href="/classes.html">Classes</a>
      <a href="/contact.html">Contact</a>
    </nav>
  );
};

export default NavBar;
